// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.usage-component {
    width: 100%;
    height: 55px;
    margin: 10px 0;
    border-radius: 5px;
    background: #FFFFFF;
    box-shadow: 0 1px 5px 0 #00000040;
}

.usage {
    display: flex;
    padding: 10px 20px 0 20px;
    justify-content: space-between;
}

.usage span {
    color: #212121;
    font-size: 12px;
}

.usage p {
    margin: 0;
    color: #4D4D4D;
    font-size: 12px;
}

.usage-slider {
    padding: 0 20px;
}

.usage-slider span {
    padding: 0;
    height: 8px;
}

@media only screen and (max-width: 600px) {

    .usage {
        padding: 10px 20px;
    }

    .usage-component {
        height: auto;
    }

    .usage span {
        font-size: 16px;
    }

    .usage p {
        font-size: 16px;
    }

    .usage-slider {
        padding: 10px 20px;
    }

    .usage-slider span {
        height: 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/css/usage-component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;;IAEI;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".usage-component {\n    width: 100%;\n    height: 55px;\n    margin: 10px 0;\n    border-radius: 5px;\n    background: #FFFFFF;\n    box-shadow: 0 1px 5px 0 #00000040;\n}\n\n.usage {\n    display: flex;\n    padding: 10px 20px 0 20px;\n    justify-content: space-between;\n}\n\n.usage span {\n    color: #212121;\n    font-size: 12px;\n}\n\n.usage p {\n    margin: 0;\n    color: #4D4D4D;\n    font-size: 12px;\n}\n\n.usage-slider {\n    padding: 0 20px;\n}\n\n.usage-slider span {\n    padding: 0;\n    height: 8px;\n}\n\n@media only screen and (max-width: 600px) {\n\n    .usage {\n        padding: 10px 20px;\n    }\n\n    .usage-component {\n        height: auto;\n    }\n\n    .usage span {\n        font-size: 16px;\n    }\n\n    .usage p {\n        font-size: 16px;\n    }\n\n    .usage-slider {\n        padding: 10px 20px;\n    }\n\n    .usage-slider span {\n        height: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
